module.exports = "/_next/static/images/start-exp-caed980ae33d05d2972faa0ce0d07b76.png";